import React from 'react';
import './App.css';
import Authen from './Authen';

const App = () => {
  return (
    <div className="App">
      <div className="App-header">
        <h2>Signin/Signup</h2>
      </div>
      <Authen />
    </div>
  );
};

export default App;
